export default __webpack_public_path__ + "static/media/dreamland.6e881c87.png";